import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Category, DocumentCategory } from '../../../shared/sdk';
import { DocumentCategoryAddComponent } from '../document-category-add/document-category-add.component';
import { DocumentCategoryService } from '../document-category.service';

@Component({
  selector: 'app-document-category',
  templateUrl: './document-category.component.html',
  styleUrls: ['./document-category.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentCategoryComponent implements OnInit {
  @Input() documentCategory: DocumentCategory;
  @Input() categories: Category[];
  @Input() currencyId: string;
  @Input() showDate = false;
  @Input() locale: string;
  @Output() delete = new EventEmitter<DocumentCategory>();
  @Output() edit = new EventEmitter<DocumentCategory>();

  constructor(
    private documentCategoryService: DocumentCategoryService,
    private modalService: NgbModal,
  ) {}

  get category(): Category {
    let category = this.documentCategory.category;

    if (!category && this.categories?.length) {
      category = this.categories.find(
        (c) => c.id === this.documentCategory.categoryId,
      );
    }

    return category || new Category();
  }

  ngOnInit() {}

  onDelete(): void {
    this.documentCategoryService.delete(this.documentCategory.id).subscribe(
      () => {},
      () => {},
    );

    this.delete.emit(this.documentCategory);
  }

  onEdit() {
    const modalRef = this.modalService.open(DocumentCategoryAddComponent, {
      size: 'sm',
    });
    modalRef.componentInstance.documentCategory = this.documentCategory;

    modalRef.result
      .then((dc) => {
        this.documentCategory = dc;
      })
      .catch(() => {});
  }
}
